<template>
	<div style="--aspect-ratio:4;" class="bg-img my-1 hovered">
		<div class="aspect-ratio-box-inside">
			<div class="row h-100 align-items-center">
				<div class="col">
					<p class="btn-text">ERVARINGEN</p>
				</div>
				<div class="col text-right pr-5">
					<Arrow width="40" link="/referenties"></Arrow>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Arrow from '@/components/Arrow.vue';
export default {
	components: {
		Arrow
	}
};
</script>

<style scoped>
.bg-img {
	background-image: url('../assets/bg-references.png');
	background-repeat: no-repeat;
	background-size: cover;
}

.btn-text {
	text-align: left;
	margin: 0;
	padding: 0 0 0 20px;
	color: white;
	font-size: 20px;
}
</style>
